import StencilHTMLElement from "./stencil-element";

class CardLineItem extends StencilHTMLElement {
  name = "CardLineItem";
  key;
  removeButtons;
  quantityInputs;

  constructor() {
    super();
  }

  connectedCallback() {
    // console.log(`hello from CardLineItem`);
    this.key = this.getAttribute('key');
    this.removeButtons = this.querySelectorAll('[data-remove]');
    this.quantityInputs = this.querySelectorAll('[data-quantity]');
    this.init();
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.removeButtons.forEach(button => {
      button.addEventListener('click', this.handleRemove.bind(this));
    });
    this.quantityInputs.forEach(button => {
      button.addEventListener('change', this.handleQuantityChange.bind(this));
    });
  }

  handleRemove(e) {
    MP.Extensions.Cart.change({ id: this.key, quantity: 0 });
  }

  handleQuantityChange(e) {
    MP.Extensions.Cart.change({ id: this.key, quantity: e.target.value });
  }
}

export default CardLineItem;